import type { BillingDataSubscriptionInfo } from 'reactApp/modules/billingData/billingData.types';
import type { ESubscriptionModalAction } from 'reactApp/sections/SubscriptionsPage/ui/SubscriptionModal/SubscriptionModal.analytics';
import type { Product } from 'reactApp/types/Billing';
import type { DwhData } from 'reactApp/ui/Mobile/CancelAutoRenewalModal/CancelAutoRenewalModal.types';

export interface OffersInfo {
    check?(args: CheckOffer): unknown;
    offer(args: OutflowOfferProps): unknown;
}
export interface CheckOffer {
    subscription: BillingDataSubscriptionInfo;
    product: Product;
}

export interface OutflowOfferProps extends CheckOffer {
    continueOutflow(): void;
    cancelOutflow(): void;
}

export interface OutflowOfferWebProps extends OutflowOfferProps {
    sendAnalytics?: (action: ESubscriptionModalAction) => void;
}

export interface OutflowOfferMobileProps extends OutflowOfferProps {
    dwhData: DwhData;
    isRebrandingQuotaLanding?: boolean;
    isRebranding?: boolean;
}
export const enum OutflowOffers {
    ARE_YOU_SURE = 'ARE_YOU_SURE',
    VK_MUSIC = 'VK_MUSIC',
    UNLIMITED_AUTOUPLOAD = 'UNLIMITED_AUTOUPLOAD',
    FAMILY = 'FAMILY',
    PAUSE = 'PAUSE',
    DISCOUNT = 'DISCOUNT',
    CAPTCHA_WITH_SURVEY = 'CAPTCHA_WITH_SURVEY',
}
